"use client";

import Navbar from "./Navbar";
import Hero from "./Hero";
import PowerfulFeatures from "./Powerful_feature";
import CustomerSupport from "./CustomerSupport";
import FAQ from "./Faq";
import Footer from "./Footer";

const Main = () => {
  return (
    <main className="w-full">
      <Navbar />
      <Hero />
      <PowerfulFeatures />
      <CustomerSupport />
      <FAQ />
      <Footer />
    </main>
  );
};

export default Main;
